import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=0bc52e92"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"
import style0 from "./MediaList.vue?vue&type=style&index=0&id=0bc52e92&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc52e92')) {
      api.createRecord('0bc52e92', component.options)
    } else {
      api.reload('0bc52e92', component.options)
    }
    module.hot.accept("./MediaList.vue?vue&type=template&id=0bc52e92", function () {
      api.rerender('0bc52e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media/MediaList.vue"
export default component.exports